import React from "react";
import Leads from "../../page-components/Leads/Leads";
function LeadsPage() {
  return (<div style={{ background: "white" }}>
    <Leads />
  </div>)
}

export default LeadsPage;
